let fallbackSequence = 0

export const BROWSER_EVENT_ID_MAX_LENGTH = 80
const BROWSER_EVENT_ID_PATTERN = /^[A-Za-z0-9._:-]+$/

export const normalizeBrowserEventId = (
  value: unknown
): string | undefined => {
  if (typeof value !== "string") return undefined
  const normalized = value.trim()
  if (
    !normalized ||
    normalized.length > BROWSER_EVENT_ID_MAX_LENGTH ||
    !BROWSER_EVENT_ID_PATTERN.test(normalized)
  ) {
    return undefined
  }
  return normalized
}

export const tryCreateCryptographicBrowserId = (): string | undefined => {
  try {
    const cryptoApi = globalThis.crypto
    if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
      return cryptoApi.randomUUID()
    }
    if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
      const bytes = new Uint8Array(16)
      cryptoApi.getRandomValues(bytes)
      return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("")
    }
  } catch {
    // Restrictive browser runtimes can expose crypto accessors that throw.
  }
  return undefined
}

export const createBrowserEventId = (): string => {
  const cryptographicId = tryCreateCryptographicBrowserId()
  if (cryptographicId) return cryptographicId
  fallbackSequence += 1
  return `evt_${Date.now().toString(36)}_${fallbackSequence.toString(36)}`
}
